import { contentStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsContent";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

Object.assign(contentStyles, {
    ...contentStyles,
    container: {
        css: css`
            margin: 30px 15px;
            > div {
                font-size: 15px;
            }
            div[class^="feature_container"] {
                /* > span {
                    position: relative;
                    padding-left: 10px;
                    display: block;
                    line-height: 1.6rem;
                    :before {
                        content: "";
                        height: 4px;
                        width: 4px;
                        background-color: ${getColor("text.main")};
                        border-radius: 50%;
                        display: inline-block;
                        position: absolute;
                        top: 10px;
                        left: 0;
                    }
                } */

                list-style: disc;
                padding: 0 0 0 40px;
                margin-bottom: 30px;
                > span {
                    display: list-item !important;
                    font-size: 15px;
                }
            }
            .brandVideoHeading {
                margin-top: 25px;
            }
            .brand-video {
                /* width: calc(310px * 16 / 9);
                height: 310px; */
                margin: 25px 0 0 !important;
            }

            .modal {
                display: none;
            }

            iframe {
                width: 100%;
                height: 450px;

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                width: 100%;
                                height: auto;
                            `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    )}
            }
        `,
    },
});
